




















import { computed, defineComponent } from "@vue/composition-api";
export default defineComponent({
    props: {
        enabled: { type: Boolean, default: true },
        icon: { type: String, required: true }
    },
    setup(props, { emit }) {
        const iconSrc = computed(() => {
            return require(`@/assets/icons/${props.icon}.svg`);
        });
        return {
            iconSrc
        };
    }
});
